import { CLOUDINARY_CLOUD } from "@/lib/cloudinary";
import React from "react";
import Image from "next/image";
import { FaInstagram, FaYoutube } from "react-icons/fa";

interface Footer7Props {
  logo?: {
    url: string;
    src: string;
    alt: string;
    title: string;
  };
  sections?: Array<{
    title: string;
    links: Array<{ name: string; href: string; target?: string }>;
  }>;
  description?: string;
  socialLinks?: Array<{
    icon: React.ReactElement;
    href: string;
    label: string;
  }>;
  copyright?: string;
  legalLinks?: Array<{
    name: string;
    href: string;
    target?: string;
  }>;
}

const defaultSections = [
  {
    title: "Servicios",
    links: [
      { name: "Propiedades en venta en Valencia", href: "/propiedades/venta/valencia" },
      { name: "Vende", href: "#" },
      { name: "PersonUp", href: "/personup" },
      { name: "Valora tu vivienda", href: "/valora-tu-vivienda" },
      { name: "Magazine", href: "/blog" },
      { name: "Join us", href: "#" },
    ],
  },
  {
    title: "Información",
    links: [
      { name: "Canal de denuncias", href: "/canal-de-denuncias" },
      { name: "Aviso legal", href: "/aviso-legal" },
      { name: "Privacidad", href: "/politica-de-privacidad" },
      { name: "Cookies", href: "/politica-de-cookies" },
    ],
  },
  {
    title: "Encuentranos",
    links: [
      { name: "Contacto", href: "/contacto" },
      /*
      { name: "960835224 / 722161141", href: "#" },
      { name: "Calle Juan Llorens, 44 - Valencia, España", href: "#" },
      */
      ],
  },
];

const defaultSocialLinks = [
  { icon: <FaInstagram className="size-5" />, href: "https://www.instagram.com/person.inmobiliaria/", label: "Instagram" },
  { icon: <FaYoutube className="size-5" />, href: "#", label: "Youtube" },
];

const defaultLegalLinks = [
  { name: "De persona a persona", href: "#" },
];

const Footer7 = ({
  logo = {
    url: "/",
    src: `https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/logos/logonbflat_ybusfx.png`,
    alt: "Company Logo",
    title: "",
  },
  sections = defaultSections,
  description = "En Person Inmobiliaria hacemos operaciones de compra, venta o alquiler de pisos, casas y locales en Valencia.",
  socialLinks = defaultSocialLinks,
  copyright = "© 2026 Person Inmobiliaria. Todos los derechos reservados.",
  legalLinks = defaultLegalLinks,
}: Footer7Props) => {
  return (
    <section className="pt-32 pb-16 px-6 md:px-12 lg:px-16" style={{ backgroundColor: '#193144' }}>
      <div className="w-full max-w-[75rem] mx-auto">
        <div className="flex w-full flex-col justify-between gap-10 lg:flex-row lg:items-start lg:text-left">
          <div className="flex w-full flex-col gap-6">
            {/* Logo */}
            <a href={logo.url} className="relative h-14 w-40">
              <Image
                src={logo.src}
                alt={logo.alt}
                title={logo.title}
                fill
                sizes="160px"
                className="object-contain object-left"
              />
            </a>
            <p className="max-w-[70%] text-sm text-white/80">
              {description}
            </p>
            <ul className="flex items-center space-x-6">
              {socialLinks.map((social, idx) => (
                <li key={idx} className="text-white/80 hover:text-white">
                  <a href={social.href} aria-label={social.label} target="_blank" rel="noopener noreferrer">
                    {social.icon}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="grid w-full gap-6 md:grid-cols-3 lg:gap-20">
            {sections.map((section, sectionIdx) => (
              <div key={sectionIdx}>
                <h3 className="mb-4 text-white">{section.title}</h3>
                <ul className="space-y-3 text-xs">
                  {section.links.map((link, linkIdx) => (
                    <li
                      key={linkIdx}
                      className="text-white/80 hover:text-white"
                    >
                      <a href={link.href} target={link.target} rel={link.target === "_blank" ? "noopener noreferrer" : undefined}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-8 flex flex-col justify-between gap-4 border-t border-white/20 py-8 text-xs md:flex-row md:items-center md:text-left text-white/80">
          <p className="order-2 lg:order-1">{copyright}</p>
          <ul className="order-1 flex flex-col gap-2 md:order-2 md:flex-row">
            {legalLinks.map((link, idx) => (
              <li key={idx} className="hover:text-white">
                <a href={link.href} target={link.target} rel={link.target === "_blank" ? "noopener noreferrer" : undefined}> {link.name}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export { Footer7 };

